module.exports = __webpack_public_path__ + "img/folder-favorite.36818165.svg";